import {appFetch, AppFetchResponse} from "../utils/appFetch";

const getTemplatesAnalyzer = (days: number, selectedDomain: string): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `statistics/templates-analyzer/${days}?domain=${selectedDomain}`,
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
        },
        domain: selectedDomain,
        isEncrypted: true,
    });
}

export default getTemplatesAnalyzer;